module.exports = __webpack_public_path__ + "img/0b5bfef93a864cb047503daf56620568.png";